import styleInject from '../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".HeaderContainer-module_container__YGHlv{align-items:center;background:#fff;box-shadow:0 1px 0 var(--black-5percent);box-sizing:border-box;display:flex;height:56px;padding:8px;position:sticky;top:0;z-index:var(--layer-header)}";
var style = {"container":"HeaderContainer-module_container__YGHlv"};
styleInject(css_248z);

export { style as default };
//# sourceMappingURL=HeaderContainer.module.css.js.map
